import { useQuery } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';
import { Account } from '@/types/types';

export const useAccounts = () => {
  const { axiosInstance } = useApi();

  return useQuery({
    queryKey: queryKeys.accounts.all.queryKey,
    queryFn: async () => {
      const { data } = await axiosInstance.get<Account[]>('/api/v1/accounts');
      return data;
    },
  });
};

export default useAccounts;
